module.exports = __webpack_public_path__ + "static/img/64.7fea82b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/64.jpg
// module id = hCT0
// module chunks = 0